if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"WPPOpenCoreOS","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(345|625|992)|3(44|543|96)|8(579|713|87)|[79]228)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}